/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:07:07 
 * @Last Modified by:   pcjser 
 * @Last Modified time: 2018-04-19 09:07:07 
 */

const Loading = () => null

export default Loading


// WEBPACK FOOTER //
// ./src/components/Loading/index.jsx